import { Button } from './Button.tsx';
import { ChevronLeftIcon } from './icons.tsx';

interface BackButtonProps {
  onClick: () => void;
  /** Button label — defaults to "Terug" */
  label?: string;
  className?: string;
}

export function BackButton({ onClick, label = 'Terug', className }: BackButtonProps) {
  return (
    <Button
      variant="ghost"
      icon={<ChevronLeftIcon />}
      onClick={onClick}
      title={label}
      className={className}
    >
      {label}
    </Button>
  );
}
